import React from "react";
import "./about.css";
import { Container, Row, Col } from "react-bootstrap";
import Tilt from "react-parallax-tilt";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import LaptopImg from "../../assets/home-main.svg";

const skills = [
  "JavaScript",
  "React.js",
  "Next.js",
  "Node.js",
  "Express",
  "MongoDB",
  "HTML",
  "CSS",
  "GenAi",
];

const About = () => {
  return (
    <section className="home-about-section" id="about">
      <Container fluid>
        <Row className="about-row">
          {/* LEFT CONTENT */}
          <Col md={7} className="about-left-col">
            <div className="about-left">
              <h2 className="about-title">
                Let me <span>introduce</span> myself
              </h2>

              <p>
                Hi, I&apos;m <strong>Dhiraj Dhiman</strong>, a MERN Stack
                Developer focused on building scalable, high-performance web
                applications.
              </p>

              <p>
                I work across the full stack — developing responsive,
                user-friendly interfaces with React and building secure,
                reliable APIs using Node.js, Express, and MongoDB.
              </p>

              <p>
                I enjoy solving real-world problems through clean code,
                thoughtful system design, and modern development practices that
                scale well in production.
              </p>

              <div className="skills">
                {skills.map((skill) => (
                  <span key={skill}>{skill}</span>
                ))}
              </div>
            </div>
          </Col>

          {/* RIGHT IMAGE */}
          <Col md={5} className="about-right-col">
            <Tilt tiltMaxAngleX={8} tiltMaxAngleY={8}>
              <img
                src={LaptopImg}
                alt="Developer Illustration"
                className="about-image"
              />
            </Tilt>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Please don&apos;t hesitate to reach out to me and{" "}
              <span className="yellow">connect.</span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/dhiraj002"
                  target="_blank"
                  rel="noreferrer"
                  className="  "
                  aria-label="github"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/dhiraj-dhiman02/"
                  target="_blank"
                  rel="noreferrer"
                  className=""
                  aria-label="linkedin"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
